export const MarketFrieze = ({ className = "" }) => (
  <div className={`market-frieze w-full ${className}`} aria-hidden="true" />
);

export const MarketFriezeMini = ({ className = "" }) => (
  <div className={`market-frieze-mini w-full ${className}`} aria-hidden="true" />
);
